import PropTypes from 'prop-types';
import DefaultImageSrc from '../assets/defaultImage.png';

const Img = ({ alt, ...props }) => {

    const commonProps = {
        loading: 'lazy',
        decoding: 'async',
        ...props,
    };

    return (
        <img
            alt={alt}
            {...commonProps}
            onError={(e) => {
                if (e.currentTarget) {
                    e.currentTarget.src = DefaultImageSrc;
                    e.currentTarget.style = 'object-fit: cover; width: 100%;';
                    e.currentTarget.onerror = null;
                    e.currentTarget.onError = null;
                }
            }}
        />
    );
};

Img.propTypes = {
    alt: PropTypes.string,
};

export default Img;
